import { PurchaseOrder, ReceivedQuantities } from 'types/purchaseOrder';

export type MarkPurchaseOrderReceivedModalProps = {
  isOpen: boolean;
  onClose: () => void;
  purchaseOrder?: PurchaseOrder;
  onPurchaseOrderUpdated?: (purchaseOrder: PurchaseOrder) => void;
};

export const toOrderDetailId = (value?: string | { _id?: string }) =>
  typeof value === 'string' ? value : value?._id ?? '';

export const formatReceivedQuantity = (
  boxQuantity: number,
  itemQuantity: number,
) => `${itemQuantity} items (${boxQuantity} boxes)`;

export const getItemsPerBox = (detail: {
  boxQuantity: number;
  itemQuantity: number;
}) => {
  if (detail.boxQuantity > 0 && detail.itemQuantity > 0) {
    return detail.itemQuantity / detail.boxQuantity;
  }

  return 1;
};

export const getReceivedForSku = (
  receivedQuantities: ReceivedQuantities | undefined,
  skuId: string,
) => receivedQuantities?.[skuId] ?? { boxQuantity: 0, itemQuantity: 0 };

export const convertEnteredQuantity = (
  entered: number,
  enterAsItems: boolean,
  itemsPerBox: number,
) => {
  if (enterAsItems) {
    return {
      boxQuantity: itemsPerBox > 0 ? entered / itemsPerBox : 0,
      itemQuantity: entered,
    };
  }

  return {
    boxQuantity: entered,
    itemQuantity: entered * itemsPerBox,
  };
};
